module.exports = __webpack_public_path__ + "img/(3).430d7ffe.jpg";